// Toolbar minHeights in Header.jsx — keep in sync
export const HEADER_HEIGHT = { xs: 48, sm: 64 };

export const HEADER_OFFSET = { xs: 56, sm: 72 };
